
<main>
    <div class="memberList">
        <a routerLink="/donor/donor-list/3" class="list-item">
            <h4>દાતાઓની યાદી</h4>
            <i class="ti ti-chevron-right"></i>
        </a>
        <!-- <a routerLink="/donor/donor-details" class="list-item">
            <h4>વિજેતા વિદ્યાર્થીની નોટબુક દાતાઓની યાદી</h4>
            <i class="ti ti-chevron-right"></i>
        </a>
        <a routerLink="/donor/donor-details" class="list-item">
            <h4>વિદ્યાર્થીઓની ટ્રોફીની દાતાઓની યાદી </h4>
            <i class="ti ti-chevron-right"></i>
        </a>
        <a routerLink="/donor/donor-details" class="list-item">
            <h4>ઘટના સ્થળની દાતાઓની યાદી</h4>
            <i class="ti ti-chevron-right"></i>
        </a>
        <a routerLink="/donor/donor-details" class="list-item">
            <h4>ટીમ 100</h4>
            <i class="ti ti-chevron-right"></i>
        </a> -->
    </div>
</main>